import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Grid, Stack, TextField, Typography, Button } from '@mui/material';
// New change
import Alert from '@mui/material/Alert';
import toast from 'react-hot-toast';
import { postData } from 'src/services/RestApi';

import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { useAuth } from 'src/hooks/use-auth';

export const AccountSecuritySettings = () => {
  // Signout after change password
  const router = useRouter();
  const auth = useAuth();

  const [isEditing, setIsEditing] = useState(false);

  const [oldpass, setOldPass] = useState('');
  const oldPassChange = (event) => {
    setOldPass(event.target.value);
  };

  const [newpass, setNewPass] = useState('');
  const newPassChange = (event) => {
    setNewPass(event.target.value);
  };

  const [message, setMessage] = useState('');

  const handleEdit = useCallback(() => {
    setIsEditing((prevState) => !prevState);
    apiChangePassword(isEditing);
  }, [isEditing, oldpass, newpass]);

  const apiChangePassword = async (isSubmit) => {
    if (isSubmit) {
      if (!oldpass || 0 === oldpass.length) {
        setMessage('Mật khẩu cũ yêu cầu phải có');
      } else if (!newpass && 0 === newpass.length) {
        setMessage('Mật khẩu mới yêu cầu phải có');
      } else {
        const queryParams = {
          oldpassword: oldpass,
          newpassword: newpass,
          grant_type: 'change_pass',
        };

        const { error, result } = await postData(
          'api/user/changePassword/',
          queryParams,
        );

        if (error) {
          const msg = error.message || 'Mật khẩu cũ không đúng';
          setMessage(msg);
        } else if (result) {
          auth.signOut();
          toast.success('Đổi mật khẩu thành công');
          router.push(paths.myauth.index);
        }
      }
    } else {
      setMessage();
    }
  };

  return (
    <Card>
      <CardContent>
        <Box component="form" onSubmit={(e) => {
          e.preventDefault();
          handleEdit();
        }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Typography variant="h6">Đổi mật khẩu</Typography>
              <input
                type="text"
                name="username"
                autoComplete="username"
                style={{ display: 'none' }}
                tabIndex={-1}
              />

            </Grid>
            <Grid item xs={12} sm={12} md={9}>
              <Stack direction="column" spacing={3}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ flex: 8 }}>
                    <TextField
                      disabled={!isEditing}
                      label="Mật khẩu cũ"
                      type="password"
                      name="oldpassword"
                      autoComplete="current-password"
                      sx={{
                        flexGrow: 1,
                        ...(!isEditing && {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderStyle: 'dotted',
                          },
                        }),
                      }}
                      value={oldpass}
                      onChange={oldPassChange}
                      fullWidth
                      variant='outlined'
                    />
                  </Box>
                  <Box sx={{ flex: 1, textAlign: 'right' }}>
                    <Button disabled sx={{ visibility: 'hidden' }}>
                      Sửa
                    </Button>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ flex: 8 }}>
                    <TextField
                      disabled={!isEditing}
                      label="Mật khẩu mới"
                      type="password"
                      name="newpassword"
                      autoComplete="new-password"
                      sx={{
                        flexGrow: 1,
                        ...(!isEditing && {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderStyle: 'dotted',
                          },
                        }),
                      }}
                      value={newpass}
                      onChange={newPassChange}
                      fullWidth
                      variant='outlined'
                    />
                  </Box>
                  <Box sx={{ flex: 1, textAlign: 'right' }}>
                    <Button type="submit">
                      {isEditing ? 'Lưu' : 'Sửa'}
                    </Button>
                  </Box>
                </Stack>
              </Stack>
            </Grid>

            {message && (
              <Grid item xs={12}>
                <Alert severity={message === 'success' ? 'success' : 'error'}>
                  {message === 'success'
                    ? 'Đổi mật khẩu thành công'
                    : message}
                </Alert>
              </Grid>
            )}
          </Grid>
        </Box>
      </CardContent>
    </Card>

  );
};

AccountSecuritySettings.propTypes = {
  loginEvents: PropTypes.array.isRequired,
};
